import classes from '../styles/colorsCohort.module.scss';

export const percentToColor = percent => {
  if (typeof percent === 'number') {
    if (percent < 5) {
      return classes.color0;
    }
    if (percent >= 5 && percent < 10) {
      return classes.color1;
    }
    if (percent >= 10 && percent < 15) {
      return classes.color2;
    }
    if (percent >= 15 && percent < 20) {
      return classes.color3;
    }
    if (percent >= 20 && percent < 25) {
      return classes.color4;
    }
    if (percent >= 25 && percent < 30) {
      return classes.color5;
    }
    if (percent >= 30 && percent < 35) {
      return classes.color6;
    }
    if (percent >= 35 && percent < 40) {
      return classes.color7;
    }
    if (percent >= 40 && percent < 45) {
      return classes.color8;
    }
    if (percent >= 45 && percent < 50) {
      return classes.color9;
    }
    if (percent >= 50 && percent < 55) {
      return classes.color10;
    }
    if (percent >= 55 && percent < 60) {
      return classes.color11;
    }
    if (percent >= 60 && percent < 65) {
      return classes.color12;
    }
    if (percent >= 65 && percent < 70) {
      return classes.color13;
    }
    if (percent >= 70 && percent < 75) {
      return classes.color14;
    }
    if (percent >= 75 && percent < 80) {
      return classes.color15;
    }
    if (percent >= 80 && percent < 85) {
      return classes.color16;
    }
    if (percent >= 85 && percent < 90) {
      return classes.color17;
    }
    if (percent >= 90 && percent < 95) {
      return classes.color18;
    }
    if (percent >= 95 && percent <= 100) {
      return classes.color19;
    }
    if (percent > 100 && percent <= 125) {
      return classes.color20;
    }
    if (percent > 125 && percent <= 150) {
      return classes.color21;
    }
    if (percent > 150 && percent <= 175) {
      return classes.color22;
    }
    if (percent > 175 && percent <= 200) {
      return classes.color23;
    }
    if (percent > 200) {
      return classes.color24;
    }
  }
  return null;
};

export const cohortCount = [
  {
    title: '0'
  },
  {
    title: '1'
  },
  {
    title: '2'
  },
  {
    title: '3'
  },
  {
    title: '4'
  },
  {
    title: '5'
  },
  {
    title: '6'
  },
  {
    title: '7'
  },
  {
    title: '8'
  },
  {
    title: '9'
  },
  {
    title: '10'
  },
  {
    title: '11'
  },
  {
    title: '12'
  },
  {
    title: '13'
  },
  {
    title: '14'
  },
  {
    title: '15'
  },
  {
    title: '16'
  },
  {
    title: '17'
  },
  {
    title: '18'
  },
  {
    title: '19'
  },
  {
    title: '20'
  },
  {
    title: '21'
  },
  {
    title: '22'
  },
  {
    title: '23'
  }
];
